module.exports = __webpack_public_path__ + "img/i_c_new_10.9a03eb9f.svg";